import NewYorkTimes from "~/public/static/images/png/newsLogos/newYorkTimes.png"
import NewsLogosABC from "~/public/static/images/png/newsLogos/abc7.png"
import NewsLogosNYP from "~/public/static/images/png/newsLogos/nyp.png"
import Bloomberg from "~/public/static/images/png/newsLogos/bloomberg.png"
import Pix from "~/public/static/images/png/newsLogos/pix11.png"

const NEWS_LIST = [
  {
    name: "New York Times",
    imgSrc: NewYorkTimes,
    linkHref: "https://www.nytimes.com/2015/07/19/nyregion/an-app-to-help-you-win-the-parking-ticket-war.html?_r=0",
    width: "200",
    height: "30",
  },
  {
    name: "ABC 7 New York",
    imgSrc: NewsLogosABC,
    linkHref: "https://abc7ny.com/technology/have-a-parking-ticket-theres-an-app-to-help-you-fight-it/792844/",
    width: "50",
    height: "35",
  },
  {
    name: "New York Post",
    imgSrc: NewsLogosNYP,
    linkHref: "https://nypost.com/2015/06/14/this-app-will-fight-your-parking-ticket-so-you-dont-have-to/",
    width: "200",
    height: "30",
  },
  {
    name: "Bloomberg Businessweek",
    imgSrc: Bloomberg,
    linkHref: "https://www.bloomberg.com/news/articles/2015-12-03/apps-that-fight-your-parking-tickets",
    width: "200",
    height: "30",
  },
  {
    name: "PIX 11",
    imgSrc: Pix,
    linkHref: "https://pix11.com/2015/06/15/new-app-helps-you-get-nyc-parking-tickets-dismissed/",
    width: "80",
    height: "35",
  }
]
export default NEWS_LIST
